<template>
  <div>
    <div class="grid max-w-md gap-6">
      <CommonLabel
        path="BWF/shop/product/registration/productRegistrationGuestLabel"
        class="text-xl font-medium"
      />
      <button class="btn btn-ghost w-full" @click="$emit('guest-proceed')">
        <CommonLabel path="BWF/shop/product/registration/registrationGuestLabel" />
      </button>
      <hr class="border bg-medium-grey" />
      <CheckInComponent />
    </div>
  </div>
</template>

<script setup>
import CheckInComponent from "~/templates/components/shop/account/CheckInComponent.vue";
import CommonLabel from "~/templates/components/CommonLabel.vue";

defineEmits(["guest-proceed"]);

onMounted(() => {
  window.scrollTo(0, 0);
});
</script>
